import { Item } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'
import {
  A3InnuvaOccupationCodeDocument,
  A3innuvaContractsOccupationCodeFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { SpanishContractData } from 'modules/contracts/hooks/useFetchSpanishContractData'
import {
  fullName,
  occupationCodesToOptions,
} from 'modules/payroll_integrations_a3innuva/lib/a3innuvaHelpers'

interface Props {
  form: Form
  spanishContractData: SpanishContractData
  legalEntityId: string
}

const OccupationCode = ({ form, spanishContractData, legalEntityId }: Props) => {
  const session = useCurrentSession()
  const occupationCodeName = form.get('es_occupation_code_payroll_integration_name').value
  const occupationCode = form.get('es_occupation_code_payroll_integration_code').value
  const occupationCodeId = form.get('es_occupation_code_id').value
  const spainOccupationCode = occupationCodeId
    ? spanishContractData.occupationCodes.get(String(occupationCodeId))
    : null

  const setCurrentOccupationCode = (
    a3OccupationCodes: A3innuvaContractsOccupationCodeFragment[]
  ) => {
    const currentOccupationCode = a3OccupationCodes.find(
      ({ name }) => name === spainOccupationCode?.attributes.name
    )

    if (currentOccupationCode) {
      form.setValues({
        es_occupation_code_payroll_integration_code: currentOccupationCode.code,
        es_occupation_code_payroll_integration_name: currentOccupationCode.name,
      })
    }
  }

  const isFormInitialized = () => {
    return !form.has('es_occupation_code_id')
  }

  const { data: occupationCodeStepData, loading } = useQuery(A3InnuvaOccupationCodeDocument, {
    variables: {
      companyId: session.company.id,
      currentUserId: session.access.userId,
      legalEntityId,
    },
  })

  const a3innuvaOccupationCodes =
    occupationCodeStepData?.payrollIntegrationsA3innuva.occupationCodes ?? []

  if (!loading && !isFormInitialized()) {
    setCurrentOccupationCode(a3innuvaOccupationCodes)
  }

  const options = occupationCodesToOptions(a3innuvaOccupationCodes)

  const onOccupationChanged = (item: Item) => {
    const selectedCno = a3innuvaOccupationCodes.find(({ code }) => code === item.value)

    form.setValues({
      es_occupation_code_payroll_integration_name: selectedCno?.name,
      es_occupation_code_payroll_integration_code: selectedCno?.code,
      es_occupation_code_id: undefined,
    })
  }

  const labelNotFound = () => {
    return options.length
      ? i18n.t(
          'contract_versions.forms.contract_extra_information.a3innuva.occupation_code_not_found'
        )
      : i18n.t('contract_versions.forms.contract_extra_information.a3innuva.label_not_found')
  }

  return (
    <DropdownSearchBar
      name={fullName(occupationCode, occupationCodeName)}
      label={i18n.t('contract_versions.flows.fix.steps.legal_and_extras.occupation_code.label')}
      onSelect={onOccupationChanged}
      labelNotFound={labelNotFound()}
      data={options}
      searchLabel={i18n.t(
        'contract_versions.forms.contract_extra_information.a3innuva.search_label'
      )}
      loading={loading}
      popoverWidth="s400"
      ellipsis={false}
    />
  )
}

export default observer(OccupationCode)
